exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status[data-v-23decb38]{padding:3px;border-radius:3px;background:#666;color:#fff}.status-Pending[data-v-23decb38]{background:#ffb758}.status-Approved[data-v-23decb38]{background:#6eda3d}.status-Declined[data-v-23decb38]{background:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-23decb38","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/CalendarEventStatus.vue
// module id = sixE
// module chunks = 0